var map = {
	"./en-US": [
		"743d",
		9
	],
	"./en-US.js": [
		"743d",
		9
	],
	"./ko-KR": [
		"204b",
		7
	],
	"./ko-KR.js": [
		"204b",
		7
	],
	"./pt-BR": [
		"3714",
		9,
		"lang-pt-BR"
	],
	"./pt-BR.js": [
		"3714",
		9,
		"lang-pt-BR"
	],
	"./zh-CN": [
		"2807",
		9
	],
	"./zh-CN.js": [
		"2807",
		9
	],
	"./zh-TW": [
		"8656",
		9,
		"lang-zh-TW"
	],
	"./zh-TW.js": [
		"8656",
		9,
		"lang-zh-TW"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, ids[1])
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "4aa4";
module.exports = webpackAsyncContext;